"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const visibility_icon_style_1 = __importDefault(require("./visibility.icon.style"));
class VisibilityIcon extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('vis_icon_');
        this.render = () => {
            const { classes } = this.props;
            const slashMaskId = `mask_${this.id}`;
            const eyeMaskId = `eye_${this.id}`;
            const eyePath = 'M13.5 50 C 30 18, 70 18, 86.5 50, C 70 82, 30 82, 13.5 50 z';
            return (jsx_runtime_1.jsxs("svg", Object.assign({ className: classes.root, viewBox: "0 0 100 100", "aria-hidden": "true" }, { children: [jsx_runtime_1.jsxs("clipPath", Object.assign({ id: slashMaskId }, { children: [jsx_runtime_1.jsx("rect", { "data-name": "mask-left", x: "-22", y: "-25", width: "66", height: "150" }, void 0),
                            jsx_runtime_1.jsx("rect", { "data-name": "mask-right", x: "56", y: "-25", width: "66", height: "150" }, void 0)] }), void 0),
                    jsx_runtime_1.jsx("clipPath", Object.assign({ id: eyeMaskId, clipRule: "evenodd" }, { children: jsx_runtime_1.jsx("path", { d: `M 0 0, L 100 0, 100 100, 0 100, 0 0, ${eyePath}` }, void 0) }), void 0),
                    jsx_runtime_1.jsx("rect", { "data-name": "bg", x: "0", y: "0", width: "100", height: "100", clipPath: `url(#${eyeMaskId})` }, void 0),
                    jsx_runtime_1.jsx("path", { "data-name": "eye", d: eyePath, clipPath: `url(#${slashMaskId})` }, void 0),
                    jsx_runtime_1.jsx("polygon", { "data-name": "retina", points: "35.3,50 42.6,37.3 57.3,37.3 64.7,50 57.4,62.7 42.7,62.7", clipPath: `url(#${slashMaskId})` }, void 0),
                    jsx_runtime_1.jsx("rect", { "data-name": "slash", x: "48", y: "12", width: "4", height: "76" }, void 0)] }), void 0));
        };
    }
}
exports.VisibilityIcon = VisibilityIcon;
VisibilityIcon.propTypes = {
    classes: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(visibility_icon_style_1.default)(VisibilityIcon);
//# sourceMappingURL=visibility.icon.js.map